var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardwareFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.833 32C13.833 32.75 14.433 33.5 15.333 33.5H21.333C22.233 33.5 22.833 32.75 22.833 32V30.5H13.833V32ZM18.333 3.5C12.483 3.5 7.83301 8.15 7.83301 14C7.83301 17.6 9.63301 20.75 12.333 22.55V26C12.333 26.75 12.933 27.5 13.833 27.5H22.833C23.733 27.5 24.333 26.75 24.333 26V22.55C27.033 20.6 28.833 17.45 28.833 14C28.833 8.15 24.183 3.5 18.333 3.5Z",
    fill: "#CA3C3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardwareFailure);
export default __webpack_public_path__ + "static/media/hardware_failure.ca442952027129e47d469eeedec0c461.svg";
export { ForwardRef as ReactComponent };